

import { getAssetsForResourceQuery } from '../queries';
import makeRequest from '../../../../common/utils/makeRequest';






export default async function getAssetsForResource(
apiClient,
assetIds,
{ resourceId, organisationId


})
{
  const requestParams = {
    query: getAssetsForResourceQuery,
    variables: { resourceId, organisationId },
    context: {
      module: 'assets'
    },
    fetchPolicy: 'network-only'
  };

  const { data, error } = await makeRequest({
    request: apiClient.query,
    requestParams,
    showErrorNotification: true
  });

  if (!data || !data.getAssetsForResource || error) {
    return assetIds.map((assetId) => ({
      assetId,
      assetFiles: { ORIGINAL: { status: 'ERROR' } }
    }));
  }

  return data.getAssetsForResource;
}